/// <amd-module name="Dashboards/Common/TelemetryConstants" />
export class DashboardsTelemetryConstants {
    /**
     * Area for our CI events.
     */
    public static Area: string = "Dashboards";
}
